<template>
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>

      <!-- Nome -->
      <d-col md="9" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorField('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Price -->
      <d-col md="3" class="form-group">
        <label for="fePrice">Preço</label>
        <d-input-group prepend="R$">
          <input-currency
            :state="hasErrorField('price')"
            model-index="price"
            placeholder="Total"
            :model="model"
          ></input-currency>
        </d-input-group>
        <d-form-invalid-feedback>Preço é obrigatório</d-form-invalid-feedback>
      </d-col>

    </d-form-row>

  </d-form>

</template>

<script>
import { mapActions } from 'vuex';
import { stringfy } from '_utils';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import Events from '_utils/events';
import InputCurrency from '_shared/InputCurrency.vue';
import ProductService from '_services/rest/modules/product';
import { MODEL, _LOAD_MODEL_, _SAVE_COST_SUCCESS_ } from './CostModel';

export default {
  name: 'cost-form',
  mixins: [mixin, formatErrors],
  components: {
    InputCurrency,
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
      errors: {
        name: { required: false },
        price: { required: false },
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'setCost',
      'activeAlert',
    ]),
    addNewType() {
      this.setToggle({ type: 'add_type_option_modal', bool: true });
    },
    save() {
      if (this.checkForm()) {
        this.model.slug = stringfy(this.model.name);
        ProductService.saveEntity(this.model, 'cost')
          .then(response => {
            this.success(response);
          })
          .catch(this.showError);
      }
      return null;
    },
    success(costSaved) {
      this.activeAlert({
        message: 'Custo salvo com sucesso',
        theme: 'success',
      });
      this.setCost(costSaved);
      Events.$emit(_SAVE_COST_SUCCESS_, costSaved);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover{
    color: $green;
  }
  &.fa-minus:hover{
    color: $red
  }
}
</style>
